import { Add, RemoveCircleOutline } from '@mui/icons-material';
import { Grid, Typography, Button, IconButton, useTheme, Box } from '@mui/material';
import { useRef } from 'react';

export type FileSectionProps = {
    selectedSifFile: File | null;
    onChangeSelectedSifFile: (file: File | null) => void;
    selectedMergeMode: string;
    onChangeMergeMode: (mode: string) => void;
};

export const FileSection = ({ selectedSifFile, onChangeSelectedSifFile, selectedMergeMode, onChangeMergeMode }: FileSectionProps) => {
    const { palette } = useTheme();
    const sifFileImportDialogInputRef = useRef<HTMLInputElement>(null);
    return (
        <Grid item xs="auto">
            <Box sx={{ width: '180px', bgcolor: 'white', height: '100%', p: '12px', pl: '24px' }}>
                <Grid container>
                    <Grid container item xs={12} sx={{ height: 'fit-content' }} justifyContent="space-between" alignItems="center">
                        <Grid item xs="auto" alignSelf="flex-start">
                            <Typography fontSize="12px" fontWeight={500} sx={{ mt: '12px', mb: '6px' }} color="#858585">
                                Upload File:
                            </Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <input
                                ref={sifFileImportDialogInputRef}
                                type="file"
                                name="sifFile"
                                id="sifFileImportDialogInput"
                                accept=".sif"
                                onChange={(event) => {
                                    const file = event.target.files?.[0];
                                    if (file) {
                                        onChangeSelectedSifFile(event.target.files?.[0] || null);
                                    }
                                }}
                                style={{ display: 'none' }}
                            />
                            <Button
                                sx={{ width: '100%', height: '32px', borderRadius: '8px', mb: '4px' }}
                                color="secondary"
                                disabled={!!selectedSifFile}
                                onClick={() => {
                                    sifFileImportDialogInputRef.current?.click();
                                }}
                                variant="outlined"
                            >
                                <Add />
                                <Typography fontSize="14px" fontWeight={500}>
                                    Add File
                                </Typography>
                            </Button>
                            {selectedSifFile && (
                                <Box
                                    sx={{
                                        width: '100%',
                                        height: '32px',
                                        borderRadius: '8px',
                                        borderColor: palette.secondary.main,
                                        border: 'dashed 1px',
                                        p: '8px'
                                    }}
                                >
                                    <Grid container alignItems="center" sx={{ height: '100%' }}>
                                        <Grid item xs="auto" sx={{ maxWidth: '50% !important' }}>
                                            <Typography
                                                fontSize="14px"
                                                fontWeight={500}
                                                color="secondary"
                                                sx={{
                                                    overflow: 'hidden',
                                                    textOverflow: 'ellipsis',
                                                    whiteSpace: 'nowrap'
                                                }}
                                            >
                                                {selectedSifFile ? selectedSifFile.name : 'No file selected'}
                                            </Typography>
                                        </Grid>
                                        <Grid item xs="auto" sx={{ ml: 'auto' }}>
                                            <Typography fontSize="12px" fontWeight={300}>
                                                {selectedSifFile && (selectedSifFile.size / (1024 * 1024)).toFixed(2)} MB
                                            </Typography>
                                        </Grid>
                                        <Grid item xs="auto" sx={{ ml: 'auto' }}>
                                            <IconButton
                                                onClick={() => {
                                                    if (sifFileImportDialogInputRef.current) sifFileImportDialogInputRef.current.value = '';
                                                    onChangeSelectedSifFile(null);
                                                }}
                                                disableRipple
                                                sx={{ width: '16px', height: '16px', borderRadius: '100px', bgcolor: 'white' }}
                                            >
                                                <RemoveCircleOutline htmlColor="#EF5350" />
                                            </IconButton>
                                        </Grid>
                                    </Grid>
                                </Box>
                            )}
                        </Grid>
                    </Grid>

                    {/* <Grid
                        container
                        item
                        xs={12}
                        sx={{ height: 'fit-content', mt: '8px' }}
                        justifyContent="space-between"
                        alignItems="center"
                    >
                        <Grid item container justifyContent="space-between" xs={5}>
                            <Grid item xs={10}>
                                <Typography fontSize="12px" fontWeight={500} color="#858585">
                                    Merge Processing Mode:
                                </Typography>
                            </Grid>
                            <Grid item xs="auto" sx={{ ml: 'auto', alignSelf: 'center' }}>
                                <Typography color="#EF5350" fontSize="12px" fontWeight={500}>
                                    *
                                </Typography>
                            </Grid>
                        </Grid>
                        <Grid item xs="auto">
                            <TextFieldv2
                                value={selectedMergeMode}
                                onChange={(e) => onChangeMergeMode(e.target.value)}
                                sx={{ width: '180px' }}
                                select
                            >
                                <MenuItem value="IMPORT_ALL">Import All</MenuItem>
                            </TextFieldv2>
                        </Grid>
                    </Grid> */}
                </Grid>
            </Box>
        </Grid>
    );
};
